/**
 * PlaceholderScreen — used for every section that will be built in
 * Stage 3.3. Keeps the nav + routing wired end-to-end so we can ship
 * the scaffold today and fill in real screens incrementally.
 */
import { Construction } from "lucide-react";

export function PlaceholderScreen({ title, stage }: { title: string; stage: string }) {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="max-w-md rounded-lg border border-stone-200 bg-white p-8 text-center">
        <Construction className="mx-auto size-10 text-stone-400" />
        <h2 className="mt-4 text-lg font-semibold text-stone-900">{title}</h2>
        <p className="mt-2 text-sm text-stone-500">
          This screen is built in Stage {stage}. The data model + GraphQL
          surface is already live — only the UI is pending.
        </p>
      </div>
    </div>
  );
}
